import { render, staticRenderFns } from "./BookingPopup.vue?vue&type=template&id=45bfd7a2&"
import script from "./BookingPopup.vue?vue&type=script&lang=js&"
export * from "./BookingPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45bfd7a2')) {
      api.createRecord('45bfd7a2', component.options)
    } else {
      api.reload('45bfd7a2', component.options)
    }
    module.hot.accept("./BookingPopup.vue?vue&type=template&id=45bfd7a2&", function () {
      api.rerender('45bfd7a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/vsl/VesselScheduleSearch/BookingPopup.vue"
export default component.exports